import { faWrench } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";

export default function ConfigActions(props: any) {
    return (
        <Dropdown align={'end'}>
            <Dropdown.Toggle className="btn btn-secondary config-button d-flex justify-content-between align-items-center">
                <FontAwesomeIcon icon={faWrench} />
                <span>Config</span>
            </Dropdown.Toggle>
            <Dropdown.Menu className="timer-dropdown config-actions-menu">
                <Dropdown.Item as={Link} to="extract-clients">MIS Client</Dropdown.Item>
                <Dropdown.Item
                    as={Link}
                    state={{ isChild: props.isChild }}
                    to={{
                        pathname: "user-types",
                    }}
                >
                    User Types
                </Dropdown.Item>
                <Dropdown.Item as={Link} to="tasks">Tasks</Dropdown.Item>
                <Dropdown.Item as={Link} to="consumer-clients">Connected Apps</Dropdown.Item>
                <Dropdown.Item as={Link} to="pin-setting">Pin Setting</Dropdown.Item>
                <Dropdown.Item as={Link} to="attendance-configuration">Attendance Policy</Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    );
}